import app from '@devices/settings/device_settings/app';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLURemote',
	friendly_name: 'BLU Remote Control ZB',
	category: 'remote_control',
	family: 'remote_control',
	isPM: false,
	modes: {
		remote_control: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			bluetooth_settings: [
				{ title: 'buzzer', component: 'mute_ble' },
				{ title: 'beacon_mode', component: 'beacon_ble' },
				// { title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
			],
			settings: [
				{
					title: 'find_my_device',
					components: [{ title: 'find_my_device', component: 'find_ble' }],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
